import { render, staticRenderFns } from "./multi-select-menu.vue?vue&type=template&id=81d053e4&scoped=true"
import script from "./multi-select-menu.vue?vue&type=script&lang=js"
export * from "./multi-select-menu.vue?vue&type=script&lang=js"
import style0 from "./multi-select-menu.vue?vue&type=style&index=0&id=81d053e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d053e4",
  null
  
)

export default component.exports